<i2g-dialog-base>
  <i2g-loader [loaderText]="label || ('DIALOG.LOADING' | translate)">
  </i2g-loader>
</i2g-dialog-base>
